import { type FC } from 'react';

import { useSearchOffersDesktopQuery } from '@/packages/query-state/shared/store/search-offers/v3/search-offers-desktop/query';
import { useIntersectionObserver } from '@/packages/react-utils/useIntersectionObserver';

import { SEOBottomLinksBlock } from '../SEOBottomLinksBlock';

import { trackTopHitsLinkClick, trackTopHitsLinksShown } from './internal/tracking';

export const TopHitsLinksContainer: FC = () => {
  const { data } = useSearchOffersDesktopQuery();

  const topHitsLinks = data?.pages[0].seo.view.topHitsLinks;

  const { elementRef } = useIntersectionObserver<HTMLDivElement>(
    {
      observerOptions: { threshold: 0.5 },
      onInViewport({ subscribeState, observer }) {
        trackTopHitsLinksShown();

        observer.disconnect();
        subscribeState.setSubscribeUnavailable();
      },
    },
    [topHitsLinks],
  );

  if (!topHitsLinks?.length) {
    return null;
  }

  return (
    <SEOBottomLinksBlock
      links={topHitsLinks}
      ref={elementRef}
      title="Вместе с этим также ищут"
      trackLinkClick={trackTopHitsLinkClick}
    />
  );
};
